export default __webpack_public_path__ + "media/src/assets/images/LocCode-89b385afc9110509d337cd3055760527.svg";